import { LucideIcon } from '@lucide/angular';

export interface PortalHeader {
  hiddenpaths: string[];
  hiddenpagewrappers?: string[];
  accountpath: string;
  logo: string;
  items: PortalHeaderItem[];
  showLanguageSwitcher?: boolean;
}

export interface PortalHeaderItem {
  id: string;
  title: string;
  type: PortalHeaderItemType;
  requiredroles: string[];
  icon: LucideIcon;
  dataautomationid: string;
  hidden: boolean;
}

export enum PortalHeaderItemType {
  Logout = 'logout',
  Register = 'register',
  Path = 'path',
  Callback = 'callback',
  Divider = 'divider',
  TokenCopier = 'token-copier',
}
